<div
  class="indicator"
  role="progressbar"
  [style.width.px]="normalizedSize"
  [style.height.px]="normalizedSize"
  [attr.aria-valuemin]="0"
  [attr.aria-valuemax]="100"
  [attr.aria-valuenow]="isIndeterminate ? null : clampedPercentage"
  [attr.aria-busy]="isIndeterminate"
>
  <svg
    class="indicator__svg"
    [class.indeterminate]="isIndeterminate"
    [attr.viewBox]="'0 0 ' + normalizedSize + ' ' + normalizedSize"
  >
    <circle
      class="indicator__track"
      [attr.cx]="center"
      [attr.cy]="center"
      [attr.r]="radius"
      [attr.stroke-width]="trackStrokeWidth"
    ></circle>

    <circle
      class="indicator__progress"
      [class.indeterminate]="isIndeterminate"
      [attr.cx]="center"
      [attr.cy]="center"
      [attr.r]="radius"
      [attr.stroke-width]="strokeWidth"
      [attr.stroke-dasharray]="dasharray"
      [attr.stroke-dashoffset]="dashoffset"
    ></circle>
  </svg>

  <div class="indicator__content">
    <ng-content></ng-content>
  </div>
</div>
